module.exports = __webpack_public_path__ + "resource/img/printer.34ae82df.svg";